import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import BasicAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';

const useStyles = buildUseStyles('EmptyMessageList', ((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
})));

const EmptyMessageList = () => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
    >
      <BasicAlert
        message={'Send your planner any questions you have about this scenario using the input box below.'}
        severity={'warning'}
      />
    </div>
  );
};

export default EmptyMessageList;
